<template>
  <div>
    <fieldset>
      <legend>
        Riders
        <button
          class="btn btn-primary btn-sm float-right"
          v-on:click.prevent="openAddDriverModal"
        >
          Add Rider
        </button>
      </legend>
    </fieldset>

    <table class="table carpenter table-bordered table-hover">
      <thead>
        <tr>
          <th>Name</th>
          <th>Has UK Licence?</th>
          <th>Number of Accidents in the Last Three Years?</th>
        </tr>
      </thead>
      <tbody v-if="drivers && drivers.length">
        <tr
          v-bind:key="index"
          v-for="(driver, index) in drivers"
          v-on:click.prevent="openEditDriverModal(driver)"
        >
          <td>{{ driver.name }}</td>
          <td>{{ driver.has_uk_licence ? 'Yes' : 'No' }}</td>
          <td>{{ driver.accidents_in_three_years }}</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="3" class="text-center">
            You must add at least one driver. Press the "Add Driver" button to
            get started.
          </td>
        </tr>
      </tbody>
    </table>

    <add-driver
      :incident="incident"
      :hire="hire.identifier"
      v-if="modals.add"
      v-on:close="closeAddDriverModal"
      :types="types"
      v-on:added="driverWasAdded"
      :client="client"
    ></add-driver>

    <edit-driver
      :incident="incident"
      :hire="hire"
      v-if="modals.edit"
      v-on:close="closeEditDriverModal"
      :types="types"
      v-on:updated="driverWasUpdated"
      :client="client"
      :driver="editingDriver"
      v-on:deleted="removeDriver"
    ></edit-driver>
  </div>
</template>
<script>
import AddDriver from '@/components/Modules/Deployment/Children/Children/AddDriver';
import EditDriver from '@/components/Modules/Deployment/Children/Children/EditDriver';

export default {
  props: {
    hire: {
      type: Object,
      required: true
    },
    incident: {
      type: String,
      required: true
    },
    client: {
      type: Object,
      required: true
    }
  },

  components: {
    AddDriver,
    EditDriver
  },

  data() {
    return {
      editingDriver: null,
      modals: {
        add: false,
        edit: false
      }
    };
  },

  computed: {
    drivers() {
      return this.hire?.drivers || [];
    },

    types() {
      return this.$store.getters['DriverTypes/all'];
    }
  },

  methods: {
    openEditDriverModal(driver) {
      this.editingDriver = driver;
      this.modals.edit = true;
    },

    findIndex(identifier) {
      return this.drivers.findIndex(item => {
        return item.identifier === identifier;
      });
    },

    removeDriver(driver) {
      this.closeEditDriverModal();

      let index = this.findIndex(driver.identifier);

      this.drivers.splice(index, 1);

      window.toastify.success(
        'Driver Deleted',
        'The driver was deleted successfully!'
      );
    },

    driverWasUpdated(driver) {
      this.closeEditDriverModal();

      let index = this.findIndex(driver.identifier);

      this.$set(this.drivers, index, driver);

      window.toastify.success(
        'Success!',
        'The driver was updated successfully!'
      );
    },

    closeEditDriverModal() {
      this.modals.edit = false;
      this.editingDriver = null;
    },

    driverWasAdded(driver) {
      this.drivers.push(driver);
      this.closeAddDriverModal();
      window.toastify.success('Success!', 'The driver was added successfully!');
    },

    closeAddDriverModal() {
      this.modals.add = false;
    },

    openAddDriverModal() {
      this.modals.add = true;
    }
  }
};
</script>
